module.exports = __webpack_public_path__ + "assets/img/busi_cp_btn.028ef011.png";